import Vue from 'vue'

export enum ShowBookingFlagBusEvents {
    ShowBookingFlagEvent = 'show_booking_flag_bus',
}

export const showBookingFlagBus = new Vue()
